import { MAX_PERSONAL_LOAN_AMOUNT } from "@component/LoanInsurance/SmallCalculator/data";
import { faCalculator as fasCalculator } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";

interface QuestionWithAnswer {
	question: ReactNode;
	answer: ReactNode;
	variant: string;
}
interface Product {
	title: ReactNode;
	customClass: string;
	questions: QuestionWithAnswer[];
	badgeText: string;
	button: ReactNode;
}

export const PREMIUM_PRODUCTS: Product[] = [
	{
		title: (
			<>
				<span className="d-block font-weight-black my-0">Bankmonitor Biztonság</span>
				<span className="d-block font-weight-black my-0 text-uppercase h2">Komplex</span>
			</>
		),
		customClass: "highlighted",
		questions: [
			{
				question: "Mikor fizeti ki a kezdeti hitelösszeget?",
				answer: (
					<>
						<List.Item>Biztosított halála esetén</List.Item>
						<List.Item>Biztosított 70%-ot meghaladó rokkantsága esetén</List.Item>
					</>
				),
				variant: "success",
			},
			{
				question: "Mikor fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: (
					<>
						<List.Item>30 napot meghaladó táppénz esetén a betegség idejére</List.Item>
						<List.Item>30 napot meghaladó munkanélküliség esetén</List.Item>
					</>
				),
				variant: "success",
			},
			{
				question: "Mennyi ideig fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: <List.Item>Legfeljebb 18 hónapig</List.Item>,
				variant: "success",
			},
			{
				question: "Mekkora a hitelösszeg felső határa?",
				answer: (
					<>
						<List.Item>Jelzáloghitel esetén 80 millió Ft</List.Item>
						<List.Item>Személyi kölcsön esetén {MAX_PERSONAL_LOAN_AMOUNT / 1_000_000} millió Ft</List.Item>
						<List.Item>Babaváró hitel esetén 11 millió Ft</List.Item>
					</>
				),
				variant: "success",
			},
		],

		badgeText: "ONLINE kötés",
		button: (
			<Button
				variant="gold"
				icon={<FontAwesomeIcon icon={fasCalculator} />}
				className="my-3 text-uppercase"
				href="#calculator-container"
			>
				Kalkuláció indítása
			</Button>
		),
	},
	{
		title: (
			<>
				<span className="font-weight-black">Bankmonitor Biztonság</span>
				<span className="d-block font-weight-black my-0 text-uppercase h2">Élet</span>
			</>
		),
		customClass: "",
		questions: [
			{
				question: "Mikor fizeti ki a kezdeti hitelösszeget?",
				answer: (
					<>
						<List.Item>Biztosított halála esetén</List.Item>
						<List.Item>Biztosított 70%-ot meghaladó rokkantsága esetén</List.Item>
					</>
				),
				variant: "success",
			},
			{
				question: "Mikor fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: (
					<>
						<List.Item>
							Ez a csomag nem tartalmazza a törlesztőrészlet kifizetését, csak a teljes hitelösszegét.
						</List.Item>
						<br />
					</>
				),
				variant: "danger",
			},
			{
				question: "Mennyi ideig fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: <List.Item>Nem fizeti ki</List.Item>,
				variant: "danger",
			},
			{
				question: "Mekkora a hitelösszeg felső határa?",
				answer: (
					<>
						<List.Item>Jelzáloghitel esetén 80 millió Ft</List.Item>
						<List.Item>Személyi kölcsön esetén {MAX_PERSONAL_LOAN_AMOUNT / 1_000_000} millió Ft</List.Item>
						<List.Item>Babaváró hitel esetén 11 millió Ft</List.Item>
					</>
				),
				variant: "success",
			},
		],
		badgeText: "ONLINE kötés",
		button: (
			<Button
				variant="secondary"
				icon={<FontAwesomeIcon icon={fasCalculator} />}
				outlined
				className="my-3 text-uppercase"
				href="#calculator-container"
			>
				Kalkuláció indítása
			</Button>
		),
	},
	{
		title: (
			<>
				<span className="font-weight-black">Bankmonitor Biztonság</span>
				<span className="d-block font-weight-black my-0 text-uppercase h2">Jövedelem</span>
			</>
		),
		customClass: "",
		questions: [
			{
				question: "Mikor fizeti ki a kezdeti hitelösszeget?",
				answer: (
					<List.Item>
						Ez a csomag nem fizeti ki a kezdeti hitelösszeget, csak a törlesztő részletét.
					</List.Item>
				),
				variant: "danger",
			},
			{
				question: "Mikor fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: (
					<>
						<List.Item>30 napot meghaladó táppénz esetén a betegség idejére</List.Item>
						<List.Item>30 napot meghaladó munkanélküliség esetén</List.Item>
					</>
				),
				variant: "success",
			},
			{
				question: "Mennyi ideig fizeti ki a törlesztőrészlettel azonos összeget?",
				answer: <List.Item>Legfeljebb 18 hónapig</List.Item>,
				variant: "success",
			},
			{
				question: "Mekkora a hitelösszeg felső határa?",
				answer: (
					<>
						<List.Item>Jelzáloghitel esetén 80 millió Ft</List.Item>
						<List.Item>Személyi kölcsön esetén {MAX_PERSONAL_LOAN_AMOUNT / 1_000_000} millió Ft</List.Item>
						<List.Item>Babaváró hitel esetén 11 millió Ft</List.Item>
					</>
				),
				variant: "success",
			},
		],
		badgeText: "ONLINE kötés",
		button: (
			<Button
				variant="secondary"
				icon={<FontAwesomeIcon icon={fasCalculator} />}
				outlined
				className="my-3 text-uppercase"
				href="#calculator-container"
			>
				Kalkuláció indítása
			</Button>
		),
	},
];
